import $axios from './api';

export const list = async () => {
	const { data } = await $axios.get('/v1/author/country/list', {});
	return data;
};
